import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { MobileAppVersionItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useMobileAppVersionContext } from "../../context/MobileAppVersionContext/MobileAppVersionContext";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const EditMobileAppVersion = () => {
	const { id } = useParams<{ id: string }>();
	const { updateMobileAppVersion, loadingEditMobileAppVersionData, getMobileAppVersionDetails } = useMobileAppVersionContext();

	useEffect(() => {
		if (id) {
			getMobileAppVersionDetails(id);
		}
	}, [id]);

	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Mobil Uygulama Sürümünü Güncelle</h3>
				<Divider />
				<Collapse
					items={MobileAppVersionItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={updateMobileAppVersion} type="default" loading={loadingEditMobileAppVersionData}>
						Güncelle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default EditMobileAppVersion;
